/**
 * 图表组件注册大型配置表。
 *
 * 工作台 / 我的分析 / 报表右侧弹窗：按 chart_type 查组件名称、图标与懒加载路径。
 *
 * @core WorkBench、MyAnalyze 与拖拉拽「添加图表」弹窗共用；放 DashboardLayout 会导致工作台反向依赖报表组件路径。
 */

import BarIcon from '@/pages/datalab/assets/img/bar-chart.svg';
import HistogramIcon from '@/pages/datalab/assets/img/stack-bar-chart.svg';
import pieIcon from '@/pages/datalab/assets/img/pie-chart.svg';
import lineChartIcon from '@/pages/datalab/assets/img/line-chart.svg';
import percentLineChartIcon from '@/pages/datalab/assets/img/percent-line-chart.svg';
import tableIcon from '@/pages/datalab/assets/img/tableShow.png';
import bigNumberIcon from '@/pages/datalab/assets/img/big-number-chart.png';
import mixedIcon from '@/pages/datalab/assets/img/mixed-chart.svg';
import numberTrendIcon from '@/pages/datalab/assets/img/number-trend-chart.png';
import DimnumberTrendIcon from '@/pages/datalab/assets/img/dim-number-trend.png';
import MapIcon from '@/pages/datalab/assets/img/countries.png';
import wordCloudIcon from '@/pages/datalab/assets/img/wordcloud.png';
import horizontalBarIcon from '@/pages/datalab/assets/img/horizontal-bar-chart.svg';
import percentStackBarIcon from '@/pages/datalab/assets/img/percent-stack-bar-chart.png';
import { ChartType } from '@dbl/core/chart';
import { ChartTypeInfos } from '../chartSwitch/config';
import type { TChartComponentConfig } from './types';

export const COMPONENT_CONFIG = {
  [ChartType.Bar]: {
    id: ChartType.Bar,
    name: 'Bar Chart',
    nameCn: '柱状图',
    icon: BarIcon,
    path: '',
  },
  [ChartType.Line]: {
    id: ChartType.Line,
    name: 'Line Chart',
    nameCn: '折线图',
    icon: lineChartIcon,
    path: '',
  },
  [ChartType.PercentLine]: {
    id: ChartTypeInfos[ChartType.PercentLine].nameEn,
    icon: percentLineChartIcon,
    name: ChartTypeInfos[ChartType.PercentLine].nameEn,
    nameCn: ChartTypeInfos[ChartType.PercentLine].nameCn,
    path: '',
  },
  [ChartType.EventLine]: {
    id: ChartType.EventLine,
    name: 'Event Line Chart',
    nameCn: '事件折线图',
    icon: lineChartIcon,
    path: '',
  },
  [ChartType.Pie]: {
    id: ChartType.Pie,
    name: 'Pie Chart',
    nameCn: '饼图',
    icon: pieIcon,
    path: '',
  },
  [ChartType.StackBar]: {
    id: ChartType.StackBar,
    name: 'Stacked Bar',
    nameCn: '堆叠图',
    icon: HistogramIcon,
    path: '',
  },
  [ChartType.Table]: {
    id: ChartType.Table,
    name: 'Table',
    nameCn: '表格',
    icon: tableIcon,
    path: '@customComp/AnalysisTable',
  },
  [ChartType.BigNumber]: {
    id: ChartTypeInfos[ChartType.BigNumber].nameEn,
    icon: bigNumberIcon,
    name: ChartTypeInfos[ChartType.BigNumber].nameEn,
    nameCn: ChartTypeInfos[ChartType.BigNumber].nameCn,
    path: '@customComp/BigNumberChart',
  },
  [ChartType.Trend]: {
    id: ChartTypeInfos[ChartType.Trend].nameEn,
    icon: numberTrendIcon,
    name: ChartTypeInfos[ChartType.Trend].nameEn,
    nameCn: ChartTypeInfos[ChartType.Trend].nameCn,
    path: '',
  },
  [ChartType.DimNumberTrend]: {
    id: ChartTypeInfos[ChartType.DimNumberTrend].nameEn,
    icon: DimnumberTrendIcon,
    name: ChartTypeInfos[ChartType.DimNumberTrend].nameEn,
    nameCn: ChartTypeInfos[ChartType.DimNumberTrend].nameCn,
    path: '',
  },
  [ChartType.MixedChart]: {
    id: ChartTypeInfos[ChartType.MixedChart].nameEn,
    icon: mixedIcon,
    name: ChartTypeInfos[ChartType.MixedChart].nameEn,
    nameCn: ChartTypeInfos[ChartType.MixedChart].nameCn,
    path: '',
  },
  [ChartType.Map]: {
    id: ChartTypeInfos[ChartType.Map].nameEn,
    icon: MapIcon,
    name: ChartTypeInfos[ChartType.Map].nameEn,
    nameCn: ChartTypeInfos[ChartType.Map].nameCn,
    path: '',
  },
  [ChartType.WordCloud]: {
    id: ChartTypeInfos[ChartType.WordCloud].nameEn,
    icon: wordCloudIcon,
    name: ChartTypeInfos[ChartType.WordCloud].nameEn,
    nameCn: ChartTypeInfos[ChartType.WordCloud].nameCn,
    path: '',
  },
  [ChartType.HorizontalBarChart]: {
    id: ChartTypeInfos[ChartType.HorizontalBarChart].nameEn,
    icon: horizontalBarIcon,
    name: ChartTypeInfos[ChartType.HorizontalBarChart].nameEn,
    nameCn: ChartTypeInfos[ChartType.HorizontalBarChart].nameCn,
    path: '',
  },
  [ChartType.PercentStackBar]: {
    id: ChartTypeInfos[ChartType.PercentStackBar].nameEn,
    icon: percentStackBarIcon,
    name: ChartTypeInfos[ChartType.PercentStackBar].nameEn,
    nameCn: ChartTypeInfos[ChartType.PercentStackBar].nameCn,
    path: '',
  },
} as const satisfies TChartComponentConfig;
